export enum BusinessCaseTabItem {
  OVERVIEW = 'overview',
  CHECKLISTS = 'checklists',
  CUSTOMER = 'customer',
  BUYING = 'buying',
  SELLING = 'selling',
  TEST_DRIVE = 'test_drive',
  CHECKOUT = 'checkout',
  DOCUMENTS = 'documents',
  RESERVATIONS = 'reservations',
  INSURANCE = 'insurance',
  TASKS = 'tasks',
  SERVICE_CASES = 'service-cases',
  CUSTOM_NOTICES = 'custom-notices',
}
